import { useEffect, useState } from "react";
import * as statisticsApi from "@api/statistics.api";
import type { Summary } from "@api/statistics.api";

export function useHomeSummary(isAuthenticated: boolean) {
  const [summary, setSummary] = useState<Summary | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setSummary(null);
      return;
    }
    statisticsApi
      .getSummary()
      .then(setSummary)
      .catch(() => {});
  }, [isAuthenticated]);

  return summary;
}
